export const UMDLogo = ({ light = false, compact = false }) => {
  const wordmarkColor = light ? "#FFFFFF" : "#0A0A0A";
  const subColor = light ? "rgba(255,255,255,0.55)" : "#666";
  const brandBlue = "#1976D2";

  return (
    <a href="/" data-testid="logo-home-link" className="inline-flex items-center gap-3 group shrink-0">
      {/* MD mark — three vertical bars (M) + half-disc (D) in brand blue */}
      <svg
        width="44"
        height="40"
        viewBox="0 0 64 56"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className="shrink-0"
      >
        {/* M — three vertical bars */}
        <rect x="2"  y="6" width="7"  height="44" rx="3.5" fill={brandBlue} />
        <rect x="13" y="6" width="6"  height="44" rx="3"   fill={brandBlue} />
        <rect x="23" y="6" width="7"  height="44" rx="3.5" fill={brandBlue} />
        {/* D — rounded half-disc */}
        <path
          d="M36 6 H44 C55.046 6 64 16.954 64 28 C64 39.046 55.046 50 44 50 H36 Z"
          fill={brandBlue}
        />
      </svg>

      {!compact && (
        <div className="flex flex-col leading-none whitespace-nowrap">
          <span
            className="font-display text-[18px] md:text-[20px] tracking-tight"
            style={{ color: wordmarkColor }}
          >
            UNIQUE <span style={{ color: brandBlue }}>MICRO</span> DESIGN
          </span>
          <span
            className="font-mono-tech text-[9px] tracking-[0.22em] uppercase mt-1"
            style={{ color: subColor }}
          >
            Engineering IoT Solutions · Since 1983
          </span>
        </div>
      )}
    </a>
  );
};

export default UMDLogo;
